import React, {Component} from 'react';
import '../../App.css';
import FAQContent from '../FAQContent';

function FAQ() {
    return (
      <>
          <FAQContent />
      </>
    )
  }

export default FAQ;